const characters = [
  {
    name: "Jordan Reyes",
    alias: '"The Wraith"',
    role: "Protagonist · Scavenger · Protector",
    status: "Active",
    statusColor: "#C8922A",
    image:
      "https://storage.readdy-site.link/project_files/4353f4cf-bd60-4a53-b8de-9b86b4213d15/d05ab320-d21a-4032-97a2-7c2e2795691c_openart-021774822815440682bfa727eaa8ae907bb4f408e14b63dc3cf2b_0_1774822823429_2d3b9d1d.png?v=79f46b6318ed102d69ac42ebaa847259",
    traits: ["Protector", "Competitor", "Relentless"],
    quote: "I already lost him once. I will not let it happen again.",
    bio: "A former college softball star turned ruthless survivor. Jordan\'s strength was born from discipline and love — not violence. But the apocalypse rewrote her. Every swing of \'Home-Run\' is a step toward redemption, a promise to herself she refuses to break. Her protectiveness over Aidan isn\'t just romantic — it\'s atonement.",
    weaponIcon: "ri-sword-line",
    weapon: '"Home-Run" — Barbed Wire Softball Bat',
    driveIcon: "ri-heart-line",
    drive: "The guilt of the supermarket massacre — and the promise of his voice",
  },
  {
    name: "Aidan Lee",
    alias: '"The Chef"',
    role: "Survivor · Head Chef · Jordan\'s Lifeline",
    status: "Signal Confirmed",
    statusColor: "#4CAF50",
    image:
      "https://storage.readdy-site.link/project_files/4353f4cf-bd60-4a53-b8de-9b86b4213d15/f502510d-5d4f-4082-9534-1803e7540741_openart-02177482300704840df8d8926005c369421892d4819382eaa536f_0_1774823018083_1c8c99f5.png?v=f8023c00a538d05ce3df3dd4fb7ec5e2",
    traits: ["Nurturer", "Strategist", "Peacemaker"],
    quote: "See? I kept our world alive. I kept us alive.",
    bio: "A culinary school graduate who ran a food truck called \'The Wandering Skillet.\' In the apocalypse, Aidan became something unexpected: the strategist. He remembered back routes, sealed rooms, and understood clean water like a chef understands mise en place. While Jordan was the muscle, Aidan was the mind — and the soul. He didn\'t give up on hope because that would have been the real death.",
    weaponIcon: "ri-fire-line",
    weapon: "Great-Grandmother\'s Cast-Iron Skillet + \'Seasoning\' Grenades",
    driveIcon: "ri-heart-line",
    drive: "He saved a child in the chaos — and paid for it with everything",
  },
];

const contrast = [
  {
    label: "Her Method",
    jordan: "Force — swing first, ask never",
    aidan: "Strategy — think three steps ahead",
    icon: "ri-sword-line",
  },
  {
    label: "Their Weapon",
    jordan: '"Home-Run" — barbed wire softball bat',
    aidan: "Cast-iron skillet + seasoning grenades",
    icon: "ri-fire-line",
  },
  {
    label: "Their Strength",
    jordan: "Athletic precision & cold fury",
    aidan: "Calm under pressure & unbreakable hope",
    icon: "ri-shield-line",
  },
];

export default function CharactersSection() {
  return (
    <section id="characters" className="w-full bg-[#0D0D0D] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.3em] uppercase block mb-4">
            [ Survivors ]
          </span>
          <h2 className="font-['Special_Elite'] text-white text-4xl md:text-5xl">
            The People Worth <span className="text-[#C8922A]">Fighting For</span>
          </h2>
          <p className="font-['Rajdhani'] text-[#555] mt-3 text-sm tracking-wide max-w-xl mx-auto">
            One chose to fight. One chose to hope. Together, they are unstoppable.
          </p>
        </div>

        {/* Character Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
          {characters.map((char, i) => (
            <div
              key={i}
              className="border border-[#2C2C2C] hover:border-[#8B1A1A]/60 transition-all duration-500 overflow-hidden group"
            >
              <div className="flex flex-col sm:flex-row">
                {/* Image */}
                <div className="relative sm:w-52 flex-shrink-0">
                  <img
                    src={char.image}
                    alt={`${char.name} – ${char.alias} character portrait`}
                    className="w-full sm:w-52 h-72 sm:h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0D0D0D]/70 hidden sm:block" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/80 to-transparent sm:hidden" />
                </div>

                {/* Info */}
                <div className="flex-1 p-6 flex flex-col justify-between">
                  <div>
                    {/* Name & Status */}
                    <div className="flex items-start justify-between mb-3 gap-2">
                      <div>
                        <h3 className="font-['Special_Elite'] text-white text-2xl mb-0.5">
                          {char.name}
                        </h3>
                        <div className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-widest">
                          {char.alias}
                        </div>
                      </div>
                      <div
                        className="flex items-center gap-1.5 px-2 py-1 border text-xs font-['Share_Tech_Mono'] tracking-wide whitespace-nowrap flex-shrink-0"
                        style={{
                          color: char.statusColor,
                          borderColor: `${char.statusColor}50`,
                          backgroundColor: `${char.statusColor}10`,
                        }}
                      >
                        <span
                          className="w-1.5 h-1.5 rounded-full animate-pulse"
                          style={{ backgroundColor: char.statusColor }}
                        />
                        {char.status}
                      </div>
                    </div>

                    <div className="font-['Rajdhani'] text-[#555] text-xs tracking-wide mb-4 uppercase">
                      {char.role}
                    </div>

                    {/* Quote */}
                    <blockquote className="border-l-2 border-[#8B1A1A] pl-4 mb-4">
                      <p className="font-['Special_Elite'] text-[#CCCCCC] text-sm italic leading-relaxed">
                        &ldquo;{char.quote}&rdquo;
                      </p>
                    </blockquote>

                    <p className="font-['Rajdhani'] text-[#888] text-sm leading-relaxed mb-5">
                      {char.bio}
                    </p>
                  </div>

                  {/* Traits & Weapon */}
                  <div className="space-y-3">
                    <div className="flex flex-wrap gap-2">
                      {char.traits.map((trait) => (
                        <span
                          key={trait}
                          className="font-['Share_Tech_Mono'] text-[#555] text-xs border border-[#2C2C2C] px-2 py-1 tracking-wide"
                        >
                          {trait}
                        </span>
                      ))}
                    </div>
                    <div className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className={`${char.weaponIcon} text-[#C8922A] text-sm`} />
                      </div>
                      <span className="font-['Rajdhani'] text-[#777] text-xs leading-snug">
                        {char.weapon}
                      </span>
                    </div>
                    <div className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className={`${char.driveIcon} text-[#8B1A1A] text-sm`} />
                      </div>
                      <span className="font-['Rajdhani'] text-[#777] text-xs leading-snug">
                        {char.drive}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contrast Table */}
        <div className="border border-[#2C2C2C] mb-12">
          <div className="grid grid-cols-3 border-b border-[#2C2C2C]">
            <div className="px-5 py-3 font-['Share_Tech_Mono'] text-[#444] text-xs tracking-widest uppercase" />
            <div className="px-5 py-3 border-l border-[#2C2C2C] font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-widest uppercase">
              Jordan
            </div>
            <div className="px-5 py-3 border-l border-[#2C2C2C] font-['Share_Tech_Mono'] text-[#4CAF50] text-xs tracking-widest uppercase">
              Aidan
            </div>
          </div>
          {contrast.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 ${i < contrast.length - 1 ? "border-b border-[#1E1E1E]" : ""}`}
            >
              <div className="px-5 py-4 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className={`${row.icon} text-[#444] text-xs`} />
                </div>
                <span className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-wide">
                  {row.label}
                </span>
              </div>
              <div className="px-5 py-4 border-l border-[#1E1E1E]">
                <span className="font-['Rajdhani'] text-[#AAAAAA] text-sm leading-snug">
                  {row.jordan}
                </span>
              </div>
              <div className="px-5 py-4 border-l border-[#1E1E1E]">
                <span className="font-['Rajdhani'] text-[#AAAAAA] text-sm leading-snug">
                  {row.aidan}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Radio Transmission Banner */}
        <div className="border border-[#8B1A1A]/40 bg-[#8B1A1A]/5 p-8 md:p-12 text-center">
          <div className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.3em] uppercase mb-4">
            [ Walkie-Talkie Transmission — Day 847 · Grandiose Hotel ]
          </div>
          <blockquote className="font-['Special_Elite'] text-white text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto">
            &ldquo;...anyone... this is Aidan... holed up at the old Hotel...<br />
            <span className="text-[#C8922A]">repeat, Aidan is alive...</span>&rdquo;
          </blockquote>
          <p className="font-['Rajdhani'] text-[#555] text-sm mt-4 max-w-lg mx-auto">
            He didn&apos;t truly expect anyone to answer. It was an act of faith — like tossing a message in a bottle into a monstrous ocean.
          </p>
          <div className="mt-6 flex items-center justify-center gap-3">
            <div className="h-px w-12 bg-[#8B1A1A]/60" />
            <span className="font-['Share_Tech_Mono'] text-[#444] text-xs tracking-widest">
              SIGNAL RECEIVED — LOCATION TRIANGULATING
            </span>
            <div className="h-px w-12 bg-[#8B1A1A]/60" />
          </div>
        </div>
      </div>
    </section>
  );
}
